// extracted by mini-css-extract-plugin
export var buttonSize = "CtxJobSectorPersons-module--buttonSize--043b8";
export var rhSectionMediaVideos = "CtxJobSectorPersons-module--rhSectionMediaVideos--c2e4c";